import { useEffect, useState, useCallback } from "react";
import { useCheckoutState, useCheckoutDispatch } from "@hooks/useCheckout";

export const useQuickAdd = (product, productColour) => {
  const { cartIsLoading } = useCheckoutState();
  const { addCartItem } = useCheckoutDispatch();
  const [selectedColour, setSelectedColour] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  useEffect(() => {
    if (selectedColour && selectedSize) {
      addToCart();
    }
  }, [selectedColour, selectedSize]);

  useEffect(() => {
    setSelectedColour({
      handle: product.handle,
      id: product.id,
      hex: productColour.colour.hex,
      title: productColour.title,
    });
  }, []);

  const getQuickAddProduct = useCallback(() => {
    const { variants } = product;
    const getSize = (selectedoptions) =>
      selectedoptions.find((option) => option.value === selectedSize);

    const variant = variants.find((variant) => {
      const size = getSize(variant.selectedOptions);
      return size && size.value === selectedSize;
    });

    return {
      variant,
      productGroup: product.productGroup,
    };
  });

  const addToCart = useCallback(() => {
    const { variant, productGroup } = getQuickAddProduct();
    addCartItem(variant, 1, productGroup);
  });

  return {
    selectedColour,
    selectedSize,
    setSelectedSize,
    cartIsLoading,
  };
};
